module.exports = __webpack_public_path__ + "img/mirror-default-banner.137e0678.png";